import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MoreVertIcon from '@mui/icons-material/MoreVert';

import ExportDownloadMenuItem from './ExportDownloadMenuItem';
import { fetchAssessmentQcExport } from '../../services/assessments';

// Row actions for the Assessments admin tab: a 3-dot menu whose only item downloads
// the Assessment QC Co-Pilot export for the row's assessment survey.
const AssessmentActionsCell = ({ assessmentSurveyId }: { assessmentSurveyId: number }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton size="small" onClick={handleMenuOpen}>
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <ExportDownloadMenuItem
          label="Download"
          fallbackFilename={`assessment-qc-${assessmentSurveyId}.zip`}
          fetchExport={() => fetchAssessmentQcExport(assessmentSurveyId)}
          onComplete={handleMenuClose}
        />
      </Menu>
    </>
  );
};

export default AssessmentActionsCell;
